'use client';
import {
  Button,
  ButtonColor,
  ButtonSize,
  IconLightning,
} from '@leland-dev/leland-ui-library';
import { usePathname, useSearchParams } from 'next/navigation';
import React, { type FC } from 'react';

import { useAuth } from '../../context/AuthContext';
import { TYPEFORM_URLS } from '../../utils/constants';
import {
  convertUrlSearchParamsToObject,
  getHashUrlString,
} from '../../utils/url';

interface GetRecommendationsButtonProps {
  className?: string;
}

const GetRecommendationsButton: FC<GetRecommendationsButtonProps> = ({
  className = '',
}) => {
  const { currentUser } = useAuth();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const href = getHashUrlString(TYPEFORM_URLS.GET_RECOMMENDATIONS, {
    first_name: currentUser?.firstName,
    last_name: currentUser?.lastName,
    email: currentUser?.email,
    id: currentUser?.applicant?.id,
    referrer: pathname,
    ...convertUrlSearchParamsToObject(searchParams),
  });

  return (
    <a
      className={`w-full ${className}`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      id="get_recommendations--personalized_recommendations"
    >
      <Button
        label="Get personalized recommendations"
        LeftIcon={IconLightning}
        buttonColor={ButtonColor.BLACK}
        size={ButtonSize.LARGE}
      />
    </a>
  );
};

export default GetRecommendationsButton;
